module.exports = __webpack_public_path__ + "static/media/infoimgMillennialv2.84c28811.png";